import {
    MUNICIPI_INICIALITZAR,
    MUNICIPI_OBTENIR_EN_CURS,
    MUNICIPI_OBTENIR_FINALITZADA
} from './actionTypes';
import { fetchAvisosMunicipis } from '../commons/consultesServidor';
import { errorConsultaServidor } from './error';
import { selectorMunicipis } from '../selectors/selector_municipis';

/*
 * Depenent de si els municipis estan carregats o no es llença la request d'municipiInicialitzar
 ***/
export const obtenirMunicipis = () => {
    return (dispatch, getState) => {

        // Si els municipis no estan carregats s'han de carregar
        const municipis = selectorMunicipis(getState());
        if (!municipis) {
            dispatch(obtenirMunicipisEnCurs());
            return fetchAvisosMunicipis()
                .then((municipis) => {
                    dispatch(municipiInicialitzar(municipis));
                    dispatch(obtenirMunicipisFinalitzada());
                },(errorServidor) => {
                    dispatch(municipiInicialitzar({}));
                    dispatch(obtenirMunicipisFinalitzada());
                    const notificacioObtenirMunicipisError = 'Error obtenint els municipis';
                    dispatch(errorConsultaServidor(errorServidor, notificacioObtenirMunicipisError));
                });
        }
    };
};

/*
 * Fa el set del municipis a l'store de redux
 ***/
export const municipiInicialitzar = (municipis) => {
    return {
        type: MUNICIPI_INICIALITZAR,
        municipis
    };
};

const obtenirMunicipisEnCurs = () => ({ type: MUNICIPI_OBTENIR_EN_CURS});

const obtenirMunicipisFinalitzada = () => ({ type: MUNICIPI_OBTENIR_FINALITZADA});



// WEBPACK FOOTER //
// ./src/actions/municipi.js